module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_5012.3009c75e.png";